import { IContentItem } from '../../../exported/product-grid-wrapper/ProductGridWrapper';
import { Product } from './Product';
import { CONTENT_SIZE_MAP, contentSize } from '../../constants/ProductGrid';

export const DEFAULT_CONTENT_SIZE = contentSize.small;

export class GridItem {
    public w: number;
    public h: number;
    public itemType: string;
    public itemId: string | number;
    public positionIndex: number;
    public product?: Product;

    constructor(
        itemType: string,
        itemId: string,
        positionIndex: number,
        itemData?: Partial<IContentItem>,
        product?: Product
    ) {
        const itemSize =
            CONTENT_SIZE_MAP[itemData && itemData.nSize ? itemData.nSize : DEFAULT_CONTENT_SIZE];
        this.w = itemSize.w;
        this.h = itemSize.h;
        this.itemType = itemType;
        this.itemId = `${itemId}${!!product ? product.skus[0].skuId : ''}`;
        this.positionIndex = positionIndex;
        this.product = product;
    }
}
